import {currentUserMeetsUserLevel, UserLevel} from '@netx/core-user-next/utils';
import {isImageFileTypeAsset} from '@netx/core-asset-next/utils/isImageFileTypeAsset';
import {isMobile} from '@netx/core-utils';
import {
	currentUserHasAccess,
	PermissionName,
} from '@netx/core-permissions-next/enablers';
import {assetProjectEnabled} from './assetProjectEnabled';
import {type IAsset} from '@netx/core-asset-next/schema';

export const canViewAssetProjects = (asset?: IAsset): boolean => {
	if (!assetProjectEnabled()) return false;
	if (isMobile()) return false;
	if (!currentUserMeetsUserLevel(UserLevel.BROWSER)) return false;
	if (!currentUserHasAccess(PermissionName.CREATE_REVIEWS)) return false;
	if (asset && !isImageFileTypeAsset(asset.fileFormatFamily)) return false;
	return true;
};
